import { HeroFloorPlan } from "@/components/HeroFloorPlan";

/** Option 1 — Architect's Studio: full-section blueprint canvas */
export const HeroBackgroundStudio = () => (
    <>
        <div className="bg-blueprint-hero pointer-events-none absolute inset-0 opacity-90" />
        <div className="bg-blueprint-hero-major pointer-events-none absolute inset-0 opacity-80" />
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_90%_80%_at_25%_35%,rgba(255,255,255,0.72)_0%,transparent_58%)]" />
        <HeroFloorPlan variant="full" />
        <div
            className="pointer-events-none absolute -right-40 top-16 h-[540px] w-[540px] rounded-full bg-[radial-gradient(closest-side,rgba(253,185,39,0.2),transparent)]"
            aria-hidden="true"
        />
        <div
            className="pointer-events-none absolute -left-48 bottom-0 h-[460px] w-[460px] rounded-full bg-[radial-gradient(closest-side,rgba(6,78,87,0.14),transparent)]"
            aria-hidden="true"
        />
        <div
            className="pointer-events-none absolute right-0 top-1/2 hidden h-[min(520px,70vh)] w-[min(42%,520px)] -translate-y-1/2 overflow-hidden lg:block"
            aria-hidden="true"
        >
            <img src="/showcase/living.webp" alt="" className="h-full w-full scale-110 object-cover opacity-[0.08] blur-3xl" />
        </div>
    </>
);
